import { createStyles } from "src/styles/theme";

export type StylesClasses = keyof typeof styles;

const styles = createStyles({
  wrapper: {
    display: "flex",
    flexDirection: "column",
    fontSize: "16px",
  },

  label: {
    fontWeight: "600",
  },

  img: {
    width: "auto",
    height: "150px",
    maxWidth: "300px",
  },
});

export default styles;
